import { configureStore } from "@reduxjs/toolkit";
import purchaseReducer from "./purchase/prchaseSlice";
import posSlice from "./pos/posSlice";
import printSlice from "./printsetting/printSlice";
import tableOrderReducer from "./tableOrder/tableOrderSlice"; // <-- add this import

export const store = configureStore({
  reducer: {
    purchase: purchaseReducer,
    pos: posSlice,
    print: printSlice,
    tableOrder: tableOrderReducer, // <-- add this line
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
